import { render, staticRenderFns } from "./EditDocument.vue?vue&type=template&id=9facfdc6&scoped=true&"
import script from "./EditDocument.vue?vue&type=script&lang=js&"
export * from "./EditDocument.vue?vue&type=script&lang=js&"
import style0 from "./EditDocument.vue?vue&type=style&index=0&lang=less&"
import style1 from "./EditDocument.vue?vue&type=style&index=1&id=9facfdc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9facfdc6",
  null
  
)

export default component.exports